export default __webpack_public_path__ + "66b0b30e6962089584e0e9c833f7bcc1.svg";